import type { ReactNode } from "react";

export function StatusNote({
  children,
  tone = "info",
}: {
  children: ReactNode;
  tone?: "info" | "warn" | "crit";
}) {
  return <p className={`banner ${tone === "info" ? "" : tone}`}>{children}</p>;
}
